// extracted by mini-css-extract-plugin
export default {"container":"NotFound-container-fJ0iq","message":"NotFound-message-Qdgw5","image":"NotFound-image-FkW9i"};